/* eslint-disable */
'use client';

import { useTranslations } from 'next-intl';

import {
  MindboxResponseBody,
  MINDBOX_OPERATIONS,
  ResponseError
} from '@/fo/api/mindbox';

import { styles } from './AccrualHistory.styles';
import IconBrand from '@/fo/icons/base/icons/smile_white.svg';

type AccrualHistoryProps = {
  customerBalanceHistory:
    | MindboxResponseBody[typeof MINDBOX_OPERATIONS.GET_CUSTOMER_BALANCE_HISTORY]
    | ResponseError;
};

export function AccrualHistory({
  customerBalanceHistory
}: AccrualHistoryProps) {
  const slots = styles();
  const t = useTranslations();

  if ('error' in customerBalanceHistory) {
    return null;
  }

  const { customerActions } = customerBalanceHistory;

  const renderActionText = (changeAmount: number, orderId: string) => {
    if (orderId) {
      return changeAmount < 0
        ? `${t('Charged for order payment')} № ${orderId}`
        : `${t('Order')} № ${orderId}`;
    }

    return changeAmount < 0 ? t('Deducted') : t('Accrued');
  };

  return (
    <div className={slots.base()}>
      <h3 className={slots.title()}>{t('Accrual history')}</h3>
      <div className={slots.items()}>
        {customerActions.map((item) =>
          item.customerBalanceChanges.map(
            (action) =>
              action.isAvailable && (
                <div
                  className={slots.item()}
                  key={item.ids.mindboxId}
                >
                  <div className={slots.top()}>
                    <p className={slots.order()}>
                      {renderActionText(
                        action.changeAmount,
                        item.order?.ids.orderID
                      )}
                    </p>
                    <p
                      className={slots.points({
                        type: action.changeAmount > 0 ? 'accrual' : undefined
                      })}
                    >
                      {action.changeAmount}{' '}
                      <IconBrand className={slots.icon()} />
                    </p>
                  </div>
                  <div className={slots.bottom()}>
                    <p className={slots.date()}>
                      {new Date(item.dateTimeUtc).toLocaleDateString('ru-RU', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric'
                      })}
                    </p>
                  </div>
                </div>
              )
          )
        )}
      </div>
    </div>
  );
}
